import { SessionLeagueDetails, StandingsColumn } from '@/modules/league/new-components/types';

export const clubRatingColumns: StandingsColumn[] = [
  { label: 'Rank', width: 'w-12', primaryDataKey: 'CurrentSeedNumber' },
  { label: '', width: 'w-80' },
  { label: 'Previous', width: 'w-14', primaryDataKey: 'PrevSeedNumber' },
  { label: 'Rating', width: 'w-32', primaryDataKey: 'CurrentRating' },
  { label: 'Wins', width: 'w-14', primaryDataKey: 'TotalWins' },
  { label: 'Losses', width: 'w-14', primaryDataKey: 'TotalLosses' },
  { label: 'Earned', width: 'w-14', primaryDataKey: 'TotalPoints_Earned' },
  { label: 'Against', width: 'w-14', primaryDataKey: 'TotalPoints_Against' },
  { label: '# Played', width: 'w-14', primaryDataKey: 'TotalMatchDate_Played' },
];

export const factorsColumns: StandingsColumn[] = [
  { label: 'Rank', width: 'w-12', primaryDataKey: 'CurrentSeedNumber' },
  { label: '', width: 'w-80' },
  { label: 'Previous', width: 'w-14', primaryDataKey: 'PrevSeedNumber' },
  {
    label: 'Max Mvmt',
    width: 'w-14',
    primaryDataKey: 'DidUseMaxMovementRule',
    conditionKeys: ['OnStandings_HideMaxMovement'],
  },
  {
    label: 'Group Bonus',
    width: 'w-14',
    primaryDataKey: 'Group_MatchDateBonus',
    conditionKeys: Array.from(
      { length: 10 },
      (_, idx) => `Group${idx + 1}_MatchDateBonus` as keyof SessionLeagueDetails
    ),
  },
  {
    label: 'E/P Diff %',
    width: 'w-24',
    primaryDataKey: 'TotalPoints_Difference_EarnedPossible_Percentage',
    conditionKeys: ['OnStandings_HideRatingOrEarnedToPossiblePercentage'],
  },
  {
    label: 'Penalty',
    width: 'w-24',
    primaryDataKey: 'TotalMatchDate_Penalty',
    conditionKeys: ['OnStandings_HidePenalty'],
  },
  {
    label: 'E/P Diff % - Penalty',
    width: 'w-24',
    primaryDataKey: 'TotalPoints_Difference_EarnedPossible_Percentage_AfterPenalties',
    conditionKeys: ['OnStandings_HideRatingOrEarnedToPossiblePercentageMinusPenalty'],
  },
  {
    label: 'Earned',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Earned',
    conditionKeys: ['OnStandings_HideEarned'],
  },
  {
    label: 'Against',
    width: 'w-24',
    primaryDataKey: 'TotalPoints_Against',
    conditionKeys: ['OnStandings_HideAgainst'],
  },
  {
    label: 'Possible',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Possible',
    conditionKeys: ['OnStandings_HidePossible'],
  },
  { label: 'Wins', width: 'w-14', primaryDataKey: 'TotalWins' },
  { label: 'Losses', width: 'w-14', primaryDataKey: 'TotalLosses' },
  {
    label: '# Played',
    width: 'w-14',
    primaryDataKey: 'TotalMatchDate_Played',
    conditionKeys: ['OnStandings_HideNumberWeeksPlayed'],
  },
  {
    label: '# Missed',
    width: 'w-14',
    primaryDataKey: 'TotalMatchDate_Missed',
    conditionKeys: ['OnStandings_HideNumberWeeksMissed'],
  },
  {
    label: 'Miss Cur Game Day',
    width: 'w-14',
    primaryDataKey: 'DidMissCurrentMatchDate',
    conditionKeys: ['OnStandings_HideMissCurrentWeek'],
  },
];

export const upDownColumns: StandingsColumn[] = [
  { label: 'Rank', width: 'w-12', primaryDataKey: 'CurrentSeedNumber' },
  { label: '', width: 'w-80' },
  { label: 'Previous', width: 'w-14', primaryDataKey: 'PrevSeedNumber' },
  {
    label: 'Wins',
    width: 'w-14',
    primaryDataKey: 'TotalWins',
    totalKey: 'TotalMatchWins',
  },
  {
    label: 'Losses',
    width: 'w-14',
    primaryDataKey: 'TotalLosses',
    totalKey: 'TotalMatchLosses',
  },
  {
    label: 'Earned',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Earned',
    totalKey: 'TotalPointsEarned',
  },
  {
    label: 'Against',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Against',
    totalKey: 'TotalPointsAgainst',
  },
  {
    label: 'Diff',
    width: 'w-24',
    primaryDataKey: 'TotalPoints_Difference_EarnedAgainst',
    totalKey: 'TotalPointDifference_EarnedAgainst',
  },
  {
    label: 'Miss Cur Game Day',
    width: 'w-14',
    primaryDataKey: 'DidMissCurrentMatchDate',
  },
  { label: 'H2H Wins', width: 'w-14', primaryDataKey: 'TeamHeadToHeadWins' },
  {
    label: 'H2H Diff',
    width: 'w-14',
    primaryDataKey: 'TeamHeadToHead_PointDifferenceWithinHeadToHead',
  },
  { label: 'Game Day Place', width: 'w-52', primaryDataKey: 'LastGameDateGroup_Place' },
  { label: '# Played', width: 'w-14' },
];

export const customColumns: StandingsColumn[] = [
  { label: 'Rank', width: 'w-12', primaryDataKey: 'CurrentSeedNumber' },
  { label: '', width: 'w-80' },
  { label: 'Previous', width: 'w-14', primaryDataKey: 'PrevSeedNumber' },
  {
    label: 'Max Mvmt',
    width: 'w-14',
    primaryDataKey: 'DidUseMaxMovementRule',
    conditionKeys: ['OnStandings_HideMaxMovement'],
  },
  {
    label: 'Group Bonus',
    width: 'w-14',
    primaryDataKey: 'Group_MatchDateBonus',
    conditionKeys: Array.from(
      { length: 10 },
      (_, idx) => `Group${idx + 1}_MatchDateBonus` as keyof SessionLeagueDetails
    ),
  },
  {
    label: 'Total Pts',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Custom_SumOfResult',
    conditionKeys: ['OnStandings_Hide_Custom_TotalPoints_SumOfResult'],
  },
  {
    label: 'Game Pts',
    width: 'w-28',
    primaryDataKey: 'TotalPoints_Custom_ForWinningAGame',
    secondaryDataKeys: ['TotalPoints_Custom_LostForLosingGame'],
    conditionKeys: [
      'OnStandings_Hide_Custom_TotalPoints_ForWinningAGame',
      'OnStandings_Hide_Custom_TotalPoints_LostForLosingGame',
    ],
  },
  {
    label: 'Match Pts',
    width: 'w-28',
    primaryDataKey: 'TotalPoints_Custom_ForWinningAMatch',
    secondaryDataKeys: ['TotalPoints_Custom_LostForLosingAMatch'],
    conditionKeys: [
      'OnStandings_Hide_Custom_TotalPoints_ForWinningAMatch',
      'OnStandings_Hide_Custom_TotalPoints_LostForLosingAMatch',
    ],
  },
  {
    label: 'Str8 Pts',
    width: 'w-28',
    primaryDataKey: 'TotalPoints_Custom_ForWinningAStraightMatch',
    secondaryDataKeys: ['TotalPoints_Custom_LostForLosingAStraightMatch'],
    conditionKeys: [
      'OnStandings_Hide_Custom_TotalPoints_ForWinningAStraightMatch',
      'OnStandings_Hide_Custom_TotalPoints_LostForLosingAStraightMatch',
    ],
  },
  {
    label: 'Play Day Pts',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Custom_ForPlayingThatDay',
    conditionKeys: ['OnStandings_Hide_Custom_TotalPoints_ForPlayingThatDay'],
  },
  {
    label: 'Game Wins',
    width: 'w-14',
    primaryDataKey: 'TotalGameWins',
    conditionKeys: ['OnStandings_Hide_Custom_TotalGameWins'],
  },
  {
    label: 'Game Losses',
    width: 'w-14',
    primaryDataKey: 'TotalGameLosses',
    conditionKeys: ['OnStandings_Hide_Custom_TotalGameLosses'],
  },
  {
    label: 'Match Wins',
    width: 'w-14',
    primaryDataKey: 'TotalWins',
    conditionKeys: ['OnStandings_Hide_Custom_TotalMatchWins'],
  },
  {
    label: 'Match Losses',
    width: 'w-14',
    primaryDataKey: 'TotalLosses',
    conditionKeys: ['OnStandings_Hide_Custom_TotalMatchLosses'],
  },
  {
    label: 'Str8 Wins',
    width: 'w-14',
    primaryDataKey: 'TotalStraightMatchWins',
    conditionKeys: ['OnStandings_Hide_Custom_TotalStraightMatchWins'],
  },
  {
    label: 'Str8 Losses',
    width: 'w-14',
    primaryDataKey: 'TotalStraightMatchLosses',
    conditionKeys: ['OnStandings_Hide_Custom_TotalStraightMatchLosses'],
  },
  {
    label: 'Earned',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Earned',
    conditionKeys: ['OnStandings_HideEarned'],
  },
  {
    label: 'Against',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Against',
    conditionKeys: ['OnStandings_HideAgainst'],
  },
  {
    label: 'Possible',
    width: 'w-14',
    primaryDataKey: 'TotalPoints_Possible',
    conditionKeys: ['OnStandings_HidePossible'],
  },
  {
    label: '# Played',
    width: 'w-14',
    primaryDataKey: 'TotalMatchDate_Played',
    conditionKeys: ['OnStandings_HideNumberWeeksPlayed'],
  },
  {
    label: '# Missed',
    width: 'w-14',
    primaryDataKey: 'TotalMatchDate_Missed',
    conditionKeys: ['OnStandings_HideNumberWeeksMissed'],
  },
  {
    label: 'Miss Cur Game Day',
    width: 'w-14',
    primaryDataKey: 'DidMissCurrentMatchDate',
    conditionKeys: ['OnStandings_HideMissCurrentWeek'],
  },
];

export const ifpRrColumns: StandingsColumn[] = [
  { label: 'Rank', width: 'w-12', primaryDataKey: 'CurrentSeedNumber' },
  { label: '', width: 'w-80' },
  {
    label: 'Wins',
    width: 'w-14',
    primaryDataKey: 'TeamHeadToHeadWins',
    secondaryDataKeys: ['TotalWins', 'UseHeadToHeadWins'],
  },
  { label: 'Losses', width: 'w-14', primaryDataKey: 'TotalLosses' },
  { label: 'Earned', width: 'w-14', primaryDataKey: 'TotalPoints_Earned' },
  { label: 'Against', width: 'w-14', primaryDataKey: 'TotalPoints_Against' },
  {
    label: 'Diff',
    width: 'w-24',
    primaryDataKey: 'TotalPoints_Difference_EarnedAgainst',
  },
  {
    label: 'Diff %',
    width: 'w-24',
    primaryDataKey: 'TotalPoints_Difference_EarnedPossible_Percentage',
    secondaryDataKeys: ['TeamPointDifferencePercentage'],
  },
];

export const columnsMap: Record<string, StandingsColumn[]> = {
  UpDown: upDownColumns,
  Factors: factorsColumns,
  ClubRating: clubRatingColumns,
  DUPRRating: clubRatingColumns,
  Custom: customColumns,
  IFP_RR: ifpRrColumns,
};
